import { ProfileAvatars } from '$tablet-app/assets/profilePictures';
import { makeRecordImageHook } from '@akin-home/images/react';

const useRecordImage = makeRecordImageHook({ local_images: ProfileAvatars });

export default useRecordImage;
